"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationTablesData = void 0;
var TranslationTablesData = (function () {
    function TranslationTablesData() {
        this.importMap = {};
        this.exportMap = {};
    }
    TranslationTablesData.prototype.getValueOnImport = function (key, defaultValue) {
        var mlData = this.importMap[key];
        return mlData ? mlData.modelValue : defaultValue;
    };
    return TranslationTablesData;
}());
exports.TranslationTablesData = TranslationTablesData;
